import { Field } from 'devextreme/ui/pivot_grid/data_source';

export const order_2: Field = {
  dataField: 'dimensiondata_2.ord',
  dataType: 'number',
  summaryType: 'min',
  isMeasure: true,
  area: "data",
  visible: false
};

export const value_2: Field = {
  dataField: 'value_2',
  dataType: 'number',
  summaryType: 'sum',
  isMeasure: true,
  format: {
    type: 'fixedPoint',
  },
};

export const value_2_precision: Field = {
  ...value_2,
  format: {
    type: 'fixedPoint',
    precision: 3,
  },
};

export const value_2_data: Field = {
  ...value_2,
  area: 'data',
};

export const value_2_data_precision: Field = {
  ...value_2_data,
  format: {
    type: 'fixedPoint',
    precision: 3,
  },
};

export const value_2_no_year_summary: Field = {
  calculateSummaryValue: (e: any) => {
    return e.field('row') && e.field('row').name === 'year' ? undefined : e.value(false);
  },
};

export const value_2_no_year_half_year_summary: Field = {
  calculateSummaryValue: (e: any) => {
    return (e.field('row') && e.field('row').name === 'year') || (e.field('row') && e.field('row').name === 'halfYear')
      ? undefined
      : e.value(false);
  },
};

export const value_2_no_year_month_summary: Field = {
  calculateSummaryValue: (e: any) => {
    return (e.field('row') && e.field('row').name === 'year') || (e.field('row') && e.field('row').name === 'month') ? undefined : e.value(false);
  },
};

export const ertek_value_2: Field = {
  ...value_2,
  caption: 'ertek',
};

export const ertek_value_2_data: Field = {
  ...value_2_data,
  caption: 'ertek',
};

export const ertek_value_2_no_year_summary: Field = {
  ...ertek_value_2,
  ...value_2_no_year_summary,
};

export const ertek_value_2_no_year_month_summary: Field = {
  ...ertek_value_2,
  ...value_2_no_year_month_summary,
};

export const ertek_value_2_data_no_year_summary: Field = {
  ...ertek_value_2_data,
  ...value_2_no_year_summary,
};

export const ertek_value_2_data_no_year_month_summary: Field = {
  ...ertek_value_2_data,
  ...value_2_no_year_month_summary,
};

export const terajoule_value_2: Field = {
  ...value_2,
  caption: 'Terajoule',
};

export const terajoule_value_2_data: Field = {
  ...value_2_data,
  caption: 'Terajoule',
};

export const terajoule_value_2_data_precision: Field = {
  ...value_2_data_precision,
  caption: 'TJ (NCV)',
};

export const TJ_GCV_value_2_data_precision: Field = {
  ...value_2_data_precision,
  caption: 'TJ (GCV)',
};

export const TJ_value_2_data_precision: Field = {
  ...value_2_data_precision,
  caption: 'TJ',
};

export const KTOE_value_2_data_precision: Field = {
  ...value_2_data_precision,
  caption: 'ktoe',
};

export const terajoule_value_2_no_year_summary: Field = {
  ...terajoule_value_2,
  ...value_2_no_year_summary,
};

export const TJ_value_2_data_precision_year_summary: Field = {
  ...TJ_value_2_data_precision,
};

export const TJ_value_2_data_precision_no_year_summary: Field = {
  ...TJ_value_2_data_precision,
  ...value_2_no_year_summary,
};

export const terajoule_value_2_no_year_month_summary: Field = {
  ...terajoule_value_2,
  ...value_2_no_year_month_summary,
};

export const terajoule_value_2_data_no_year_summary: Field = {
  ...terajoule_value_2_data,
  ...value_2_no_year_summary,
};

export const terajoule_value_2_data_no_year_month_summary: Field = {
  ...terajoule_value_2_data,
  ...value_2_no_year_month_summary,
};

export const terajoule_brutto_value_2: Field = {
  ...value_2,
  caption: 'terajoule_brutto',
};

export const terajoule_brutto_value_2_precision: Field = {
  ...value_2_precision,
  caption: 'terajoule_brutto',
};

export const terajoule_brutto_value_2_data: Field = {
  ...value_2_data,
  caption: 'terajoule_brutto',
};

export const terajoule_brutto_value_2_no_year_summary: Field = {
  ...terajoule_brutto_value_2,
  ...value_2_no_year_summary,
};

export const terajoule_brutto_value_2_no_year_month_summary: Field = {
  ...terajoule_brutto_value_2,
  ...value_2_no_year_month_summary,
};

export const terajoule_brutto_value_2_data_no_year_summary: Field = {
  ...terajoule_brutto_value_2_data,
  ...value_2_no_year_summary,
};

// TO-DO: felvenni no halfYear summary-t mindenhova
export const terajoule_brutto_value_2_no_year_half_year_summary: Field = {
  ...terajoule_brutto_value_2,
  ...value_2_no_year_half_year_summary,
};

// TO-DO: felvenni no halfYear summary-t mindenhova
export const terajoule_brutto_value_2_precision_no_year_half_year_summary: Field = {
  ...terajoule_brutto_value_2_precision,
  ...value_2_no_year_half_year_summary,
};

// TO-DO: felvenni no halfYear summary-t mindenhova
export const terajoule_brutto_value_2_data_no_year_half_year_summary: Field = {
  ...terajoule_brutto_value_2_data,
  ...value_2_no_year_half_year_summary,
};

export const terajoule_brutto_value_2_data_no_year_month_summary: Field = {
  ...terajoule_brutto_value_2_data,
  ...value_2_no_year_month_summary,
};

export const terajoule_netto_value_2: Field = {
  ...value_2,
  caption: 'terajoule_netto',
};

export const terajoule_netto_value_2_precision: Field = {
  ...value_2_precision,
  caption: 'terajoule_netto',
};

export const terajoule_netto_value_2_data: Field = {
  ...value_2_data,
  caption: 'terajoule_netto',
};

export const terajoule_netto_value_2_data_precision: Field = {
  ...value_2_data_precision,
  caption: 'terajoule_netto',
};

export const terajoule_netto_value_2_no_year_summary: Field = {
  ...terajoule_netto_value_2,
  ...value_2_no_year_summary,
};

export const terajoule_netto_value_2_no_year_month_summary: Field = {
  ...terajoule_netto_value_2,
  ...value_2_no_year_month_summary,
};

export const terajoule_netto_value_2_data_no_year_summary: Field = {
  ...terajoule_netto_value_2_data,
  ...value_2_no_year_summary,
};

// TO-DO: felvenni no halfYear summary-t mindenhova
export const terajoule_netto_value_2_no_year_half_year_summary: Field = {
  ...terajoule_netto_value_2,
  ...value_2_no_year_half_year_summary,
};

// TO-DO: felvenni no halfYear summary-t mindenhova
export const terajoule_netto_value_2_precision_no_year_half_year_summary: Field = {
  ...terajoule_netto_value_2_precision,
  ...value_2_no_year_half_year_summary,
};

// TO-DO: felvenni no halfYear summary-t mindenhova
export const terajoule_netto_value_2_data_no_year_half_year_summary: Field = {
  ...terajoule_netto_value_2_data,
  ...value_2_no_year_half_year_summary,
};

export const terajoule_netto_value_2_data_no_year_month_summary: Field = {
  ...terajoule_netto_value_2_data,
  ...value_2_no_year_month_summary,
};

export const ezer_tonna_value_2: Field = {
  ...value_2,
  caption: 'ezer_tonna',
};

export const ezer_tonna_value_2_data: Field = {
  ...value_2_data,
  caption: 'ezer_tonna',
};

export const ezer_tonna_value_2_data_precision: Field = {
  ...value_2_data_precision,
  caption: 'ezer_tonna',
};

export const ezer_tonna_value_2_no_year_summary: Field = {
  ...ezer_tonna_value_2,
  ...value_2_no_year_summary,
};

export const ezer_tonna_value_2_no_year_month_summary: Field = {
  ...ezer_tonna_value_2,
  ...value_2_no_year_month_summary,
};

export const ezer_tonna_value_2_data_no_year_summary: Field = {
  ...ezer_tonna_value_2_data,
  ...value_2_no_year_summary,
};

export const ezer_tonna_value_2_data_no_year_month_summary: Field = {
  ...ezer_tonna_value_2_data,
  ...value_2_no_year_month_summary,
};

export const kilo_tonna_value_2: Field = {
  ...value_2,
  caption: 'kilo_tonna',
};

export const kilo_tonna_value_2_data: Field = {
  ...value_2_data,
  caption: 'kilo_tonna',
};

export const kilo_tonna_value_2_no_year_summary: Field = {
  ...kilo_tonna_value_2,
  ...value_2_no_year_summary,
};

export const kilo_tonna_value_2_no_year_month_summary: Field = {
  ...kilo_tonna_value_2,
  ...value_2_no_year_month_summary,
};

export const kilo_tonna_value_2_data_no_year_summary: Field = {
  ...kilo_tonna_value_2_data,
  ...value_2_no_year_summary,
};

export const kilo_tonna_value_2_data_no_year_month_summary: Field = {
  ...kilo_tonna_value_2_data,
  ...value_2_no_year_month_summary,
};

export const ezer_kobmeter_value_2: Field = {
  ...value_2,
  caption: 'ezer_kobmeter',
};

export const ezer_kobmeter_value_2_data: Field = {
  ...value_2_data,
  caption: 'ezer_kobmeter',
};

export const ezer_kobmeter_value_2_no_year_summary: Field = {
  ...ezer_kobmeter_value_2,
  ...value_2_no_year_summary,
};

export const ezer_kobmeter_value_2_no_year_month_summary: Field = {
  ...ezer_kobmeter_value_2,
  ...value_2_no_year_month_summary,
};

export const ezer_kobmeter_value_2_data_no_year_summary: Field = {
  ...ezer_kobmeter_value_2_data,
  ...value_2_no_year_summary,
};

export const ezer_kobmeter_value_2_data_no_year_month_summary: Field = {
  ...ezer_kobmeter_value_2_data,
  ...value_2_no_year_month_summary,
};

export const millio_kobmeter_value_2: Field = {
  ...value_2,
  caption: 'Mm3',
};

export const millio_kobmeter_value_2_data: Field = {
  ...value_2_data,
  caption: 'Mm3',
};

export const millio_kobmeter_value_2_data_precision: Field = {
  ...value_2_data_precision,
  caption: 'Mm3',
};

export const millio_kobmeter_value_2_no_year_summary: Field = {
  ...millio_kobmeter_value_2,
  ...value_2_no_year_summary,
};

export const millio_kobmeter_value_2_no_year_month_summary: Field = {
  ...millio_kobmeter_value_2,
  ...value_2_no_year_month_summary,
};

export const millio_kobmeter_value_2_data_no_year_summary: Field = {
  ...millio_kobmeter_value_2_data,
  ...value_2_no_year_summary,
};

export const millio_kobmeter_value_2_data_no_year_month_summary: Field = {
  ...millio_kobmeter_value_2_data,
  ...value_2_no_year_month_summary,
};

export const kilowatt_value_2_data: Field = {
  ...value_2_data,
  caption: 'kW',
};

export const kilowatt_value_2_data_no_year_summary: Field = {
  ...kilowatt_value_2_data,
  ...value_2_no_year_summary,
};

export const megawatt_value_2: Field = {
  ...value_2,
  caption: 'MW',
};

export const megawatt_value_2_data: Field = {
  ...value_2_data,
  caption: 'MW',
};

export const kilowatt_ora_value_2: Field = {
  ...value_2,
  caption: 'kWh',
};

export const megawatt_value_2_max: Field = {
  ...megawatt_value_2,
  summaryType: 'max',
};

export const megawatt_value_2_data_max: Field = {
  ...megawatt_value_2_data,
  summaryType: 'max',
};

export const kilowatt_ora_value_2_data: Field = {
  ...value_2_data,
  caption: 'kWh',
};

export const kilowatt_ora_value_2_no_year_summary: Field = {
  ...kilowatt_ora_value_2,
  ...value_2_no_year_summary,
};

export const kilowatt_ora_value_2_no_year_month_summary: Field = {
  ...kilowatt_ora_value_2,
  ...value_2_no_year_month_summary,
};

export const kilowatt_ora_value_2_data_no_year_summary: Field = {
  ...kilowatt_ora_value_2_data,
  ...value_2_no_year_summary,
};

export const kilowatt_ora_value_2_data_no_year_month_summary: Field = {
  ...kilowatt_ora_value_2_data,
  ...value_2_no_year_month_summary,
};

export const megawatt_ora_value_2: Field = {
  ...value_2,
  caption: 'MWh',
};

export const megawatt_ora_value_2_data: Field = {
  ...value_2_data,
  caption: 'MWh',
};

export const megawatt_ora_value_2_no_year_summary: Field = {
  ...megawatt_ora_value_2,
  ...value_2_no_year_summary,
};

export const megawatt_ora_value_2_no_year_month_summary: Field = {
  ...megawatt_ora_value_2,
  ...value_2_no_year_month_summary,
};

export const megawatt_ora_value_2_data_no_year_summary: Field = {
  ...megawatt_ora_value_2_data,
  ...value_2_no_year_summary,
};

export const megawatt_ora_value_2_data_no_year_month_summary: Field = {
  ...megawatt_ora_value_2_data,
  ...value_2_no_year_month_summary,
};

export const gigawatt_ora_value_2: Field = {
  ...value_2,
  caption: 'gigawatt_ora',
};

export const gigawatt_ora_value_2_data: Field = {
  ...value_2_data,
  caption: 'gigawatt_ora',
};

export const gigawatt_ora_value_2_no_year_summary: Field = {
  ...gigawatt_ora_value_2,
  ...value_2_no_year_summary,
};

export const gigawatt_ora_value_2_no_year_month_summary: Field = {
  ...gigawatt_ora_value_2,
  ...value_2_no_year_month_summary,
};

export const gigawatt_ora_value_2_data_no_year_summary: Field = {
  ...gigawatt_ora_value_2_data,
  ...value_2_no_year_summary,
};

export const gigawatt_ora_value_2_data_no_year_month_summary: Field = {
  ...gigawatt_ora_value_2_data,
  ...value_2_no_year_month_summary,
};

export const forint_value_2: Field = {
  ...value_2,
  caption: 'ezer_forint',
};

export const forint_value_2_data: Field = {
  ...value_2_data,
  caption: 'ezer_forint',
};

export const huf_value_2_data: Field = {
  ...value_2_data,
  caption: 'forint',
};

export const forint_value_2_no_year_summary: Field = {
  ...forint_value_2,
  ...value_2_no_year_summary,
};

export const forint_value_2_no_year_month_summary: Field = {
  ...forint_value_2,
  ...value_2_no_year_month_summary,
};

export const forint_value_2_data_no_year_summary: Field = {
  ...forint_value_2_data,
  ...value_2_no_year_summary,
};

export const forint_value_2_data_no_year_month_summary: Field = {
  ...forint_value_2_data,
  ...value_2_no_year_month_summary,
};

export const petajoule_value_2: Field = {
  ...value_2,
  caption: 'Petajoule',
};

export const petajoule_value_2_data: Field = {
  ...value_2_data,
  caption: 'Petajoule',
};

export const petajoule_value_2_no_year_summary: Field = {
  ...petajoule_value_2,
  ...value_2_no_year_summary,
};

export const petajoule_value_2_no_year_month_summary: Field = {
  ...petajoule_value_2,
  ...value_2_no_year_month_summary,
};

export const petajoule_value_2_data_no_year_summary: Field = {
  ...petajoule_value_2_data,
  ...value_2_no_year_summary,
};

export const petajoule_value_2_data_no_year_month_summary: Field = {
  ...petajoule_value_2_data,
  ...value_2_no_year_month_summary,
};

export const szazalek_value_2: Field = {
  ...value_2,
  caption: 'szazalek',
};

export const szazalek_value_2_data: Field = {
  ...value_2_data,
  caption: 'szazalek',
};

export const szazalek_value_2_no_year_summary: Field = {
  ...szazalek_value_2,
  ...value_2_no_year_summary,
};

export const szazalek_value_2_no_year_month_summary: Field = {
  ...szazalek_value_2,
  ...value_2_no_year_month_summary,
};

export const szazalek_value_2_data_no_year_summary: Field = {
  ...szazalek_value_2_data,
  ...value_2_no_year_summary,
};

export const szazalek_value_2_data_no_year_month_summary: Field = {
  ...szazalek_value_2_data,
  ...value_2_no_year_month_summary,
};

export const huf_kilowatt_ora_value_2: Field = {
  ...value_2,
  caption: 'huf_kilowatt_ora',
};

export const huf_kilowatt_ora_value_2_data: Field = {
  ...value_2_data,
  caption: 'huf_kilowatt_ora',
};

export const huf_kilowatt_ora_value_2_no_year_summary: Field = {
  ...huf_kilowatt_ora_value_2,
  ...value_2_no_year_summary,
};

export const huf_kilowatt_ora_value_2_no_year_month_summary: Field = {
  ...huf_kilowatt_ora_value_2,
  ...value_2_no_year_month_summary,
};

export const huf_kilowatt_ora_value_2_data_no_year_summary: Field = {
  ...huf_kilowatt_ora_value_2_data,
  ...value_2_no_year_summary,
};

// TO-DO: felvenni no halfYear summary-t mindenhova
export const huf_kilowatt_ora_value_2_data_no_year_half_year_summary: Field = {
  ...huf_kilowatt_ora_value_2_data,
  ...value_2_no_year_half_year_summary,
};

export const huf_kilowatt_ora_value_2_data_no_year_month_summary: Field = {
  ...huf_kilowatt_ora_value_2_data,
  ...value_2_no_year_month_summary,
};

export const huf_gigajoule_brutto_value_2: Field = {
  ...value_2,
  caption: 'huf_gigajoule_brutto',
};

export const huf_gigajoule_brutto_value_2_precision: Field = {
  ...value_2_precision,
  caption: 'huf_gigajoule_brutto',
};

export const huf_gigajoule_brutto_value_2_data: Field = {
  ...value_2_data,
  caption: 'huf_gigajoule_brutto',
};

export const huf_gigajoule_brutto_value_2_no_year_summary: Field = {
  ...huf_gigajoule_brutto_value_2,
  ...value_2_no_year_summary,
};

export const huf_gigajoule_brutto_value_2_no_year_month_summary: Field = {
  ...huf_gigajoule_brutto_value_2,
  ...value_2_no_year_month_summary,
};

export const huf_gigajoule_brutto_value_2_data_no_year_summary: Field = {
  ...huf_gigajoule_brutto_value_2_data,
  ...value_2_no_year_summary,
};

// TO-DO: felvenni no halfYear summary-t mindenhova
export const huf_gigajoule_brutto_value_2_no_year_half_year_summary: Field = {
  ...huf_gigajoule_brutto_value_2,
  ...value_2_no_year_half_year_summary,
};

// TO-DO: felvenni no halfYear summary-t mindenhova
export const huf_gigajoule_brutto_value_2_precision_no_year_half_year_summary: Field = {
  ...huf_gigajoule_brutto_value_2_precision,
  ...value_2_no_year_half_year_summary,
};

// TO-DO: felvenni no halfYear summary-t mindenhova
export const huf_gigajoule_brutto_value_2_data_no_year_half_year_summary: Field = {
  ...huf_gigajoule_brutto_value_2_data,
  ...value_2_no_year_half_year_summary,
};

export const huf_gigajoule_brutto_value_2_data_no_year_month_summary: Field = {
  ...huf_gigajoule_brutto_value_2_data,
  ...value_2_no_year_month_summary,
};

export const huf_gigajoule_netto_value_2: Field = {
  ...value_2,
  caption: 'huf_gigajoule_netto',
};

export const huf_gigajoule_netto_value_2_precision: Field = {
  ...value_2_precision,
  caption: 'huf_gigajoule_netto',
};

export const huf_gigajoule_netto_value_2_data: Field = {
  ...value_2_data,
  caption: 'huf_gigajoule_netto',
};

export const huf_gigajoule_netto_value_2_data_precision: Field = {
  ...value_2_data_precision,
  caption: 'huf_gigajoule_netto',
};

export const huf_gigajoule_netto_value_2_no_year_summary: Field = {
  ...huf_gigajoule_netto_value_2,
  ...value_2_no_year_summary,
};

export const huf_gigajoule_netto_value_2_no_year_month_summary: Field = {
  ...huf_gigajoule_netto_value_2,
  ...value_2_no_year_month_summary,
};

export const huf_gigajoule_netto_value_2_data_no_year_summary: Field = {
  ...huf_gigajoule_netto_value_2_data,
  ...value_2_no_year_summary,
};

// TO-DO: felvenni no halfYear summary-t mindenhova
export const huf_gigajoule_netto_value_2_no_year_half_year_summary: Field = {
  ...huf_gigajoule_netto_value_2,
  ...value_2_no_year_half_year_summary,
};

// TO-DO: felvenni no halfYear summary-t mindenhova
export const huf_gigajoule_netto_value_2_precision_no_year_half_year_summary: Field = {
  ...huf_gigajoule_netto_value_2_precision,
  ...value_2_no_year_half_year_summary,
};

export const huf_gigajoule_netto_value_2_data_precision_no_year_half_year_summary: Field = {
  ...huf_gigajoule_netto_value_2_data_precision,
  ...value_2_no_year_half_year_summary,
};

// TO-DO: felvenni no halfYear summary-t mindenhova
export const huf_gigajoule_netto_value_2_data_no_year_half_year_summary: Field = {
  ...huf_gigajoule_netto_value_2_data,
  ...value_2_no_year_half_year_summary,
};

export const huf_gigajoule_netto_value_2_data_no_year_month_summary: Field = {
  ...huf_gigajoule_netto_value_2_data,
  ...value_2_no_year_month_summary,
};
